import { getEffectiveSoundOutputVolume } from './soundEffectsManager';
import { isExploreUnknownKendrexColonyAudioSuppressed } from '../utils/exploreUnknownKendrexColonyAudio';

/**
 * Simple utility for playing sound effects
 * Sound effects are short, one-time sounds that don't need caching
 * Uses global sound settings from soundEffectsManager
 *
 * @param {string} soundPath - Path to the sound file (e.g., '/sounds/click.mp3')
 * @param {number | null} [relativeClipGain=null] - Per-clip gain (0–1 typical), multiplied by the user's sound volume. Omit or null for gain 1 (fully follows the slider).
 * @returns {HTMLAudioElement|null} The audio element when playback was started, or null when skipped/failed.
 */
export function playSoundEffect(soundPath, relativeClipGain = null) {
  if (!soundPath) return null;

  if (isExploreUnknownKendrexColonyAudioSuppressed(soundPath)) {
    return null;
  }

  // MOBILE FIX: Don't play sounds when page is hidden (screen locked)
  if (typeof document !== 'undefined' && document.hidden) {
    return null;
  }

  const clipGain = relativeClipGain != null ? relativeClipGain : 1;
  const volume = getEffectiveSoundOutputVolume(clipGain, soundPath);
  if (volume === null) return null;
  
  try {
    const audio = new Audio(soundPath);
    audio.volume = volume;
    audio.play().catch(err => {
      // Silently fail if audio can't play (e.g., user hasn't interacted with page yet)
      console.debug('Sound effect play failed:', err);
    });
    return audio;
  } catch (error) {
    console.debug('Sound effect error:', error);
    return null;
  }
}

